/** @internal */
export enum PromptStyle {
    SLIDE = 'SLIDE',
    PUBLISHER_CUSTOM = 'PUBLISHER_CUSTOM',
    NATIVE = 'NATIVE',
}
